import { Injectable } from '@angular/core';
import { ImmutableContext } from '@ngxs-labs/immer-adapter';
import { Action, createSelector, Selector, State, StateContext } from '@ngxs/store';
import { SamwinCallInfoRemoteDto } from 'src/generated/signalR/samwin-call-info-remote-dto';
import { ClearSelectedCall, SelectCall } from './call-wait-list-behaviour.actions';

export interface CallWaitListBehaviourStateModel {
   [instanceId: string]: CallWaitListBehaviourInstance;
}

export interface CallWaitListBehaviourInstance {
   selectedCall: SamwinCallInfoRemoteDto;
   selectedCallPosition?: number;
}

export function DefaultCallWaitListBehaviourInstance(): CallWaitListBehaviourInstance {
   return {
      selectedCall: null,
      selectedCallPosition: null,
   };
}

@State<CallWaitListBehaviourStateModel>({
   name: 'callWaitListBehaviour',
   defaults: {},
})
@Injectable()
export class CallWaitListBehaviourState {
   public static callWaitListBehaviourForInstance(brickInstanceId: string) {
      return createSelector([CallWaitListBehaviourState], (state: CallWaitListBehaviourStateModel) => {
         return this.getSpecificBehaviourStateOrDefault(state, brickInstanceId);
      });
   }

   private static getSpecificBehaviourStateOrDefault(state: CallWaitListBehaviourStateModel, brickInstanceId: string): CallWaitListBehaviourInstance {
      const value = state[brickInstanceId];
      if (value) {
         return value;
      } else {
         return DefaultCallWaitListBehaviourInstance();
      }
   }

   @Selector([CallWaitListBehaviourState])
   public static selectedCall(state: CallWaitListBehaviourStateModel) {
      return (brickInstanceId: string) => {
         return this.getSpecificBehaviourStateOrDefault(state, brickInstanceId).selectedCall;
      };
   }

   @Selector([CallWaitListBehaviourState])
   public static selectedCallPosition(state: CallWaitListBehaviourStateModel) {
      return (brickInstanceId: string) => {
         return this.getSpecificBehaviourStateOrDefault(state, brickInstanceId).selectedCallPosition;
      };
   }

   @Action(SelectCall)
   @ImmutableContext()
   public selectCall(ctx: StateContext<CallWaitListBehaviourStateModel>, action: SelectCall) {
      ctx.setState((state: CallWaitListBehaviourStateModel) => {
         const behavior = CallWaitListBehaviourState.getSpecificBehaviourStateOrDefault(state, action.brickInstanceId);
         behavior.selectedCall = action.call;
         behavior.selectedCallPosition = action.position;
         state[action.brickInstanceId] = behavior;
         return state;
      });
   }

   @Action(ClearSelectedCall)
   @ImmutableContext()
   public clearSelectedCall(ctx: StateContext<CallWaitListBehaviourStateModel>, action: ClearSelectedCall) {
      return ctx.dispatch(new SelectCall(action.brickInstanceId, null, null));
   }
}
